module.exports = __webpack_public_path__ + "img/CM-MC-25-Hyundai-Playful.64777488.jpg";